import { catchRestError, FileClient } from "../RestClient";
import { UseFormReturn } from "react-hook-form";
import { MSystemGet } from "clients/rest";
import { startOfMonth } from "services/DateService";

export type B020050Request = {
  eigyoCd: string;
  sort1: string;
  sort2: string;
  sort3: string;
} & Partial<{
  eigyoCd: string;
  uriYmdFrom: string;
  uriYmdTo: string;
  hasoYmdFrom: string;
  hasoYmdTo: string;
  bumonCdFrom: string;
  bumonCdTo: string;
  shainCdFrom: string;
  shainCdTo: string;
  uridenpyoNoFrom: string;
  uridenpyoNoTo: string;
  juchudenpyoNoFrom: string;
  juchudenpyoNoTo: string;
  tokuiCdFrom: string;
  tokuiCdTo: string;
  tokuishitenCdFrom: string;
  tokuishitenCdTo: string;
  shokaKbn: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
}>;

// Excel出力処理
export const B020050GetExcel = (props: B020050Request) => {
  return FileClient.get("b020050/get/excel", {
    params: props,
  });
};

//当月取得処理
export const B020050TogetsuYm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  await MSystemGet()
    .then((response) => {
      const firstYmd = startOfMonth(response.data.togetsuYm);
      //伝票日付の範囲(開始)初期設定
      methods.setValue("uriYmdFrom", firstYmd);
      //発送日の範囲(開始)初期設定
      methods.setValue("hasoYmdFrom", firstYmd);
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("uriYmdFrom", "");
      methods.setValue("hasoYmdFrom", "");
    });
};
